import React from 'react';
import {css} from '@emotion/react';
import SaleNavigation from "../../navigation/SaleNavigation";
import { useLocation } from 'react-router-dom'

const Footer = () => {
	const location = useLocation();
	return (
		<footer>
			<nav>
				<SaleNavigation name={location.pathname.split("/")[2]}/>
				{/*<BottomTabs />*/}
			</nav>
		</footer>
	);
};

export default Footer;
